import React, { Component } from "react";

import FormattedAmount from "pages/_components/FormattedAmount";

import GridTable from "pages/_components/GridTable/GridTable";
import CustomText from "pages/_components/CustomText/CustomText";
import { number } from "yup/lib/locale";
import { isIOS } from "react-device-detect";

class TotalAccountBalance extends Component {
    render() {
        const { totalBalanceARS, totalBalanceUSD } = this.props;

        return (
            <GridTable className="equivalent-total-balance account-totals box box-primary mb-7">
                <GridTable.Container>
                    <GridTable.Data className="total-label whitespace-nowrap">
                        <CustomText text="accounts.totalAvailableBalance" textType="I18N" />
                    </GridTable.Data>
                    <GridTable.Data
                        className={isIOS ? "pesos word-break-all align-items-center" : "pesos word-break-all"}>
                        <FormattedAmount
                            className={
                                isIOS
                                    ? "data-amount content-data-strong data-amount-ios"
                                    : "data-amount content-data-strong"
                            }
                            currency="ARS"
                            quantity={totalBalanceARS}
                        />
                    </GridTable.Data>
                    <GridTable.Data
                        className={isIOS ? "dollars word-break-all align-items-center" : "dollars word-break-all"}>
                        <FormattedAmount
                            className={
                                isIOS
                                    ? "data-amount content-data-strong whitespace-nowrap data-amount-ios"
                                    : "data-amount content-data-strong whitespace-nowrap"
                            }
                            currency="USD"
                            quantity={totalBalanceUSD}
                        />
                    </GridTable.Data>
                </GridTable.Container>
            </GridTable>
        );
    }
}
TotalAccountBalance.propTypes = {
    totalBalanceARS: number.isRequired,
    totalBalanceUSD: number.isRequired,
};

export default TotalAccountBalance;
